import React from "react";

export const EmptyState = () => (
    <div className="flex flex-col items-center mx-auto">
      <h2 className="valorant-info-section__heading text-2xl font-bold leading-none">Sorry, there are no accounts matching your selection.</h2>
      <img height="50%" width="50%" src="/images/empty-state.png" alt="No accounts found pengu"/>
    </div>
  )
